export * from './ThingRenameMutation';
